"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportBannerLoadStartBiEvent = exports.createBiLoggerFactory = void 0;
var web_bi_logger_1 = require("@wix/web-bi-logger");
var createBiLoggerFactory = function (params) {
    var biLoggerFactory = (0, web_bi_logger_1.factory)({ endpoint: 'cashier-ugc' })
        .updateDefaults({
        src: 64,
        msid: params.msid,
        productId: params.productId,
        appInstanceId: params.appInstanceId,
        app_id: params.appDefId,
        visitorId: params.visitorId,
    })
        .withUoUContext({
        msid: params.msid,
        visitorId: params.visitorId,
    });
    return biLoggerFactory;
};
exports.createBiLoggerFactory = createBiLoggerFactory;
var reportBannerLoadStartBiEvent = function (params) {
    var biLogger = (0, exports.createBiLoggerFactory)(params).logger();
    biLogger.log({ evid: 257 });
};
exports.reportBannerLoadStartBiEvent = reportBannerLoadStartBiEvent;
//# sourceMappingURL=lazy.js.map